'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = init;

var _functional = require('../utils/functional');

var _helpers = require('./_helpers');

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var swiperContainer = context.getElement('.' + context.className + '_Carousel');

  var carousel = void 0;
  var currentSizing = void 0;

  if (swiperContainer) {
    shuffleNodes((0, _functional.getElement)('ul', { context: swiperContainer }));
  }

  function shuffle(items) {
    var cached = items.slice(0);
    var temp = void 0;
    var i = cached.length;
    var rand = void 0;
    while (--i) {
      rand = Math.floor(i * Math.random());
      temp = cached[rand];
      cached[rand] = cached[i];
      cached[i] = temp;
    }
    return cached;
  }

  function shuffleNodes(list) {
    var nodes = list.children;
    var i = 0;
    nodes = Array.prototype.slice.call(nodes);
    nodes = shuffle(nodes);
    while (i < nodes.length) {
      list.appendChild(nodes[i]);
      ++i;
    }
  }

  makeCarousel();

  window.addEventListener('resize', makeCarousel);

  function makeCarousel() {
    if (currentSizing !== 'desktop' && window.innerWidth >= _utils.mediaBreakpoints.sm && carousel !== undefined) {
      carousel.destroy();
      carousel = undefined;
    } else if (currentSizing !== 'mobile' && window.innerWidth < _utils.mediaBreakpoints.sm && carousel !== undefined) {
      carousel.destroy();
      carousel = undefined;
    }

    if (window.innerWidth > _utils.mediaBreakpoints.sm) {
      var _breakpoints;

      currentSizing = 'desktop';
      carousel = (0, _helpers.initialiseSwiper)(swiperContainer, {
        loop: true,
        watchSlidesProgress: true,
        slidesPerView: 1.5,
        centeredSlides: true,
        initialSlide: 2,
        spaceBetween: 5,
        speed: 500,
        grabCursor: true,
        slideClass: context.className + '_Slide',
        breakpointsInverse: true,
        breakpoints: (_breakpoints = {}, (0, _defineProperty3.default)(_breakpoints, _utils.mediaBreakpoints.md, {
          slidesPerView: 2.5
        }), (0, _defineProperty3.default)(_breakpoints, _utils.mediaBreakpoints.lg, {
          slidesPerView: 3.5
        }), _breakpoints)
      });
    } else {
      currentSizing = 'mobile';
      carousel = (0, _helpers.initialiseSwiper)(swiperContainer, {
        loop: false,
        watchSlidesProgress: true,
        slidesPerView: 1.2,
        centeredSlides: true,
        initialSlide: 2,
        spaceBetween: 5,
        speed: 500,
        slideClass: context.className + '_Slide'
      });
    }
  }
}